module.exports = __webpack_public_path__ + "static/media/Small-Scale-Development.bb67e00c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Small-Scale-Development.gif
// module id = 320
// module chunks = 0